import { useParams, useLocation } from "react-router-dom";
import { Line, Circle } from 'rc-progress';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import '../../index.css'

import { useState, useEffect } from "react";
import { useShuffle } from '../../hooks/useShuffle'
// import { CountdownCircleTimer  } from 'react-countdown-circle-timer'
export default function Quiz1() {
  const location = useLocation();
  const { questions } = useShuffle()
  const [myQuestions, setMyQuestions] = useState([])
  const [answers, setAnswers] = useState([])
  const [x, setX] = useState(0)
  const [y, setY] = useState(5)
  const [minutes, setMinutes] = useState(0)
  const [seconds, setSeconds] = useState(0)
  const [percentage, setPercentafe] = useState(0);
  const params = useParams();
  const [type, setType] = useState("")
  const [mark, setMark] = useState(0)
  const [inCorrectAnswers, setInCorrectAnswers] = useState([])
  const [ind, setInd] = useState([])
  const [correctAnswers, setCorrectAnswers] = useState([])
  const [showResult, setShowResult] = useState(false)
  const [progressBar, setsetProgressBar] = useState(0)












  useEffect(() => {

    setType(`${params.id}`)
    let filter = []
    questions.map((question) => {
      if (question.type.includes(type)) {
        filter.push(question)

      }
      setMyQuestions(filter.slice(0, 30))
      // setMyQuestions(myQuestions.slice(0,30))
    })


  }, [questions, params.id])


  if (x >= 30) {
    setX(0)
    setY(5)
  }
  else if (y < 5) {
    setX(25)
    setY(30)
  }
  const progressPer = () => {
    let length = 0;
    for (let a = 0; a < answers.length; a++) {
      if (answers[a] != null) {
        length += 3.33;
        setsetProgressBar(length)
      }

    }

  }
  const calcMark = () => {

    let myMark = 0;


    for (let a = 0; a < answers.length; a++) {

      if (answers[a] === correctAnswers[a] && answers[a] != null) {
        myMark += 1;
        setMark(myMark)
        setPercentafe(Math.round(mark * 3.3333))

      }
      else if (answers[a] !== correctAnswers[a]) {

        inCorrectAnswers.push(answers[a]);
        ind.push(a)

      }





    }
  }

  const handleSubmit = () => {
    setShowResult(true)
    calcMark()
  }

  {/* $(document).ready(function() {
    var progress_circle = $(".my-progress-bar").gmpc({
        line_width: 6,
        color: "#1ABC9C",
        starting_position: 25,
        percent: 25,
        percentage: true,
        text: "JQuery Script Net"
    }).gmpc('animate', 80, 3000);
}); */}





  //  let answers = new Array(30)
  //  const children = ({ remainingTime }) => {
  //    const minutes = Math.floor(remainingTime / 60)
  //    const seconds = remainingTime % 60

  //    return `${minutes}:${seconds}`
  //  }

  const handleValue = (value, index) => {
    answers[index] = value
    progressPer()



  }
  const correct = (value, index) => {
    correctAnswers[index] = value
  }
  // console.log("Correct", correctAnswers)
  //  console.log("mark",mark)
  return (
    <div className="container quiz">
      {/* <CountdownCircleTimer
        isPlaying
        colors="#EF798A"
        duration={hourSeconds}
        initialRemainingTime={remainingTime % hourSeconds}
        onComplete={(totalElapsedTime) => ({
          shouldRepeat: remainingTime - totalElapsedTime > minuteSeconds
        })}
      >
        {({ elapsedTime, color }) => (
          <span style={{ color }}>
            {renderTime(getTimeMinutes(hourSeconds - elapsedTime))}
          </span>
        )}
      </CountdownCircleTimer>
          <CountdownCircleTimer
            isPlaying
            duration={minuteSeconds}
            initialRemainingTime={remainingTime % minuteSeconds}
            onComplete={(totalElapsedTime) => ({
               shouldRepeat:remainingTime - totalElapsedTime > 0 
            })}
            colors={['#004777', '#F7B801', '#A30000', '#A30000']}
            colorsTime={[7, 5, 2, 0]}
         >
            
            {({ elapsedTime, color }) => (
          <span style={{ color }}>
            {renderTime(getTimeSeconds(elapsedTime))}
          </span>
        )}
              
            </CountdownCircleTimer> */}

      {!showResult && <div>
        <>
          <Line percent={(progressBar)} strokeWidth={1} strokeColor="#e24e29" />

        </>
        <button className="btn-prev-next" onClick={() => ((setX(x - 5), setY(y - 5)), window.scrollTo({ top: 0, behavior: 'smooth' }))}>الصفحة السابقة</button>
        <button className="btn-prev-next" onClick={() => ((setX(x + 5), setY(y + 5)), window.scrollTo({ top: 0, behavior: 'smooth' }))}>الصفحة التالية </button>
        {y == 30 ? <button className="btn-prev-next" onClick={() => (handleSubmit())}>انهاء</button> : <br></br>}
        {myQuestions && myQuestions.map((question, i) => {

          return (

            <div dir="rtl" className={i >= x && i < y ? "show bg-primary answers" : "hide bg-primary answers"} key={i}>
              <h2 className="question"> {i + 1}- {question.title} </h2>
              <img src={question.img}></img>
              <br></br>
              <ul className="answers-list">
                {question.choices.map((choice, j) => {
                  return (

                    <div key={i + j * -1 - 1} className="answer-div"><input type={"radio"} value={choice} name={i} onChange={(e) => { handleValue(e.target.value, i); 
                      correct(question.correctAnswer, i);
                      //  console.log("answers", answers)
                       }}
                     /> <label>{choice}</label> </div>
                  )

                }
                )}
              </ul>


            </div>)

        }
        )}
        <>
          <Line percent={(progressBar)} strokeWidth={1} strokeColor="#e24e29" />

        </>
        <br></br>
        {/* <h3>صفحة  {y/5}</h3> */}
        <br></br>
        <button className="btn-prev-next" onClick={() => ((setX(x - 5), setY(y - 5)), window.scrollTo({ top: 0, behavior: 'smooth' }))}>الصفحة السابقة</button>
        <button className="btn-prev-next" onClick={() => ((setX(x + 5), setY(y + 5)), window.scrollTo({ top: 0, behavior: 'smooth' }))}>الصفحة التالية </button>
        {y == 30 ? <button className="btn-prev-next" onClick={() => (handleSubmit())}>اتهاء</button> : <br></br>}
      </div>}
      {showResult && <div>


        <br></br>
        <br></br>
        {
          <div className="container ">

            {/* <h2 dir="rtl" className=""> عدد الاسئلة المجاب عليها : <span className="text-primary-color">  {Math.round(progressBar / 3.33)}  </span>من 30</h2> */}
            <div className="score-div">
              <div>
                <div className="score-progress">
                  <CircularProgressbar 
                    value={Math.round((mark / 3) * 10)}
                    text={Math.round((mark / 3) * 10) + "%"}
                    className={mark >85?"pass":"fail"}
                  />
                <h2 className="text-center">    {mark > 85 ? <span className="rightAnswer">ناجح</span> : <span className="wrongAnswer">راسب</span>}</h2>

                </div>
              </div>
              <h2 dir="rtl" className="text-center"> عدد الاسئلة المجاب عليها : <span className="text-primary-color">  {Math.round(progressBar / 3.33)}  </span>من 30</h2>

            </div>
         <div className="table-div" dir="rtl">
         <table dir="rtl" className="table-questions">
              <thead className="table-head">
                <tr>

                  <th className="my-Question ">السؤال</th>
                  <th className="wrongAnswer"> اجابتك الخاطئة</th>
                  <th className="rightAnswer">الاجابة الصحيحة </th>

                </tr>
              </thead>
              <tbody className="table-body">
                {inCorrectAnswers && inCorrectAnswers.map((ans, i) => {
                  return (

                    <tr className="table-row" key={i}>

                      <td className="myQuestion"> {myQuestions[ind[i]].title}  {<img src={myQuestions[ind[i]].img}></img>} </td>
                      <td className="answer  "> {ans} </td>
                      <td className="answer "> {correctAnswers[ind[i]]}</td>

                    </tr>


                  )
                })}


              </tbody>
            </table>
          </div>
          </div>
        }
        <br></br>
        <br></br>
        {/* <CountdownCircleTimer
        isPlaying
        colors="#EF798A"
        duration={mark*2}
        initialRemainingTime={remainingTime % hourSeconds}
        onComplete={(totalElapsedTime) => ({
          shouldRepeat: remainingTime - totalElapsedTime > minuteSeconds
        })} /> */}
        {/* <CountdownCircleTimer
        isPlaying
        colors="#EF798A"
        duration={6}
        initialRemainingTime={-60 }
        onComplete={(totalElapsedTime) => ({
         
        })}
      ></CountdownCircleTimer> */}

        {/* $(document).ready(function() {
    var progress_circle = $(".my-progress-bar").gmpc({
        line_width: 6,
        color: "#1ABC9C",
        starting_position: 25,
        percent: 25,
        percentage: true,
        text: "JQuery Script Net"
    }).gmpc('animate', 80, 3000);
}); */}
        {/* <h2 dir="rtl" >النتيجة  : {Math.round((mark / 3) * 10)}%     {mark > 85 ? <span className="rightAnswer">ناجح</span> : <span className="wrongAnswer">راسب</span>}</h2>
        <div style={{ width: 200, height: 200 }} className="text-right">
          <CircularProgressbar
            value={Math.round((mark / 3) * 10)}
            text={Math.round((mark / 3) * 10) + "%"}
           

          />
        </div> */}

      </div>}
    </div>
  )
}
